import type { IEnvironment } from "./IEnvironment";

export const environment: IEnvironment = {
  production: true,
  apiURL: "api",
  gtmKeys: {
    default: "GTM-T72LDNWZ",
    audi: "GTM-T72LDNWZ",
    cupra: "GTM-T72LDNWZ",
    seat: "GTM-T72LDNWZ",
    skoda: "GTM-T72LDNWZ",
    vw: "GTM-T72LDNWZ",
    vwtransportbilar: "GTM-T72LDNWZ",
  },
  enabledFeatures: {},
  productImageFallbackURL: "/assets/img/product_fallback.png",
  hotjarId: "3106788",
};

export type { IEnvironment };
